import { getLocaleStore } from '@/i18n/index';
import { IImageEffectShadowType, IImageLayerProps, ImageEffectStrokeType } from '@/version-types';

export const ImgEffectResultImgSize = 1.4;

export const ComplexBridgeFilterID = 'ComplexBridge';

export const getImageEffectResultImgSize = (imageData: IImageLayerProps) => {
    if (!imageData || !imageData.effect) {
        return 1.4;
    }

    const { effect } = imageData;

    if (effect?.shadow && effect?.shadow?.length > 0 && effect.screenshotUrl && !effect.effectPosition) {
        const shadow = effect.shadow.find((item) => {
            return item.type !== IImageEffectShadowType.base && item.type !== undefined;
        });

        // 除了基础投影外的投影需要4倍的图层大小
        if (shadow) {
            return 4;
        }
    }

    // 普通特效只需要1.4倍图层大小
    return 1.4;
};

export const getDefaultStrokeValue = () => ({
    color: '#2773ffff',
    width: 0.2,
    hidden: false,
    strokeType: ImageEffectStrokeType.normal,
});

export const getDefaultGlowValue = () => ({
    color: '#ffff007f',
    hidden: false,
    width: 0.3,
});

export const getDefaultShadowValue = () => ({
    color: '#2773ff99',
    blur: 0.3,
    hidden: false,
    x: -0.02,
    y: 0,
});

export const getStrokeTypeOptions = () => {
    const { $t } = getLocaleStore();
    return [
        {
            url: 'strokeType0',
            label: $t((v) => v.imageEffectPanel.constants.normal),
            value: ImageEffectStrokeType.normal,
        },
        {
            url: 'strokeType1',
            label: $t((v) => v.imageEffectPanel.constants.outSolidLine),
            value: ImageEffectStrokeType.outSolidLine,
        },
        {
            url: 'strokeType2',
            label: $t((v) => v.imageEffectPanel.constants.outDashedLine),
            value: ImageEffectStrokeType.outDashedLine,
        },
        {
            url: 'strokeType3',
            label: $t((v) => v.imageEffectPanel.constants.tornPaper),
            value: ImageEffectStrokeType.tornPaper,
        },
    ];
};

export const getEmptyEffect = () => ({
    effectAlpha: 1,
    glow: [],
    shadow: [],
    stroke: [],
    screenshotUrl: '',
});
